import { axiosInstance } from '@/modules/shared/lib/axios'
import { GroupListItem } from '../types'

export async function getGroups(tenantId?: string) {
  const { data } = await axiosInstance.get<GroupListItem[]>('/config-api/group', {
    params: tenantId ? { tenantId } : undefined,
  })
  return data
}
